import React from 'react';
import { NotificationData } from '../../../services/notificationService';
import './NotificationDropdown.scss';

interface NotificationDropdownProps {
  isVisible: boolean;
  notifications: NotificationData[];
  onClose: () => void;
  onNotificationClick: (notification: NotificationData) => void;
}

export const NotificationDropdown: React.FC<NotificationDropdownProps> = ({
  isVisible,
  notifications,
  onClose,
  onNotificationClick,
}) => {
  if (!isVisible) return null;

  const formatTime = (timestamp: number) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffInHours = (now.getTime() - date.getTime()) / (1000 * 60 * 60);
    
    if (diffInHours < 1) return 'Just now';
    if (diffInHours < 24) return `${Math.floor(diffInHours)}h ago`;
    return `${Math.floor(diffInHours / 24)}d ago`;
  };

  return (
    <>
      <div className="notification-overlay" onClick={onClose} />
      <div className="notification-dropdown">
        <div className="notification-header">
          <h3>Notifications</h3>
        </div>
        <div className="notification-list">
          {notifications.length === 0 ? (
            <div className="notification-empty">No notifications</div>
          ) : (
            notifications.map((notification) => (
              <div
                key={notification.id}
                className={`notification-item ${!notification.read ? 'unread' : ''}`}
                onClick={() => onNotificationClick(notification)}
              >
                <div className="notification-content">
                  <div className="notification-title">{notification.title}</div>
                  <div className="notification-body">{notification.body}</div>
                  <div className="notification-time">{formatTime(notification.timestamp)}</div>
                </div>
                {!notification.read && <div className="notification-dot" />}
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
};